module.exports = __webpack_public_path__ + "media/CompTool.172b15a7.jpg";